let initialState = null;

function signed_blob(state = initialState, action) {
  if (action.type === "CONTRACT_SIGNED_INSIGN") {
    return action.res;
  } else return state;
}

export default signed_blob;
